// 导航
export const MENU_LIST = [
    {
        id: '1',
        name: '首页',
        code: 'home',
        icon: 'el-icon-s-home',
        path: '/',
    },
    {
        id: '2',
        name: '竞赛流程',
        code: 'flowPath',
        path: '/flowPath'
    },
    {
        id: '8',
        name: '证书查询',
        code: 'scoreQuery',
        path: '/scoreQuery',
    },
    {
        id: '10',
        name: '报名中心',
        code: 'registrationCenter',
        path: '/registrationCenter',
    }
]


// WEBPACK FOOTER //
// ./src/constants/common.js